import React from "react";

import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Button } from "../../../../../../../../components/Form";
import { Color } from "../../../../../../../../components/Form/Button";
import useStyles from "./styles";

type Props = {
  onSave: () => void;
  onCancel: () => void;
  isLoading: boolean;
  isShowSave: boolean;
};

const OrderButtons: React.FC<Props> = ({ onSave, onCancel, isLoading, isShowSave }) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();

  return (
    <Box className={classes.main}>
      <Button
        customColor={Color.CANCEL}
        loading={isLoading}
        disabled={isLoading}
        onClick={onCancel}
      >
        {translate("cancel")}
      </Button>
      {isShowSave && (
        <Button
          customColor={Color.SUCCESS}
          loading={isLoading}
          disabled={isLoading}
          onClick={onSave}
        >
          {translate("save")}
        </Button>
      )}
    </Box>
  );
};

export default OrderButtons;
